/** @flow */
import * as Sentry from '@sentry/browser';
import AuthenticationAPI from 'common/modules/authentication/services/AuthenticationAPI';
import RefreshToken from 'common/modules/session/domain/RefreshToken';
import SessionStorage from 'common/modules/session/services/SessionStorage';
import { beginSession } from '../session/actions/sessionActions';

export const LOGIN_REQUEST = 'authentication/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'authentication/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'authentication/LOGIN_FAILURE';

export const RESET_PASSWORD = 'authentication/RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'authentication/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'authentication/RESET_PASSWORD_FAILURE';

export function login(email: string, password: string) {
  return async (dispatch: any) => {
    dispatch({ type: LOGIN_REQUEST });

    try {
      const { refreshToken, expiration } = await AuthenticationAPI.authenticate(email, password);
      SessionStorage.updateRefreshToken(new RefreshToken(refreshToken, expiration));

      dispatch({ type: LOGIN_SUCCESS });
      dispatch(beginSession());
      Sentry.setUser({ email });
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE, error: error });
    }
  };
}

export function resetPassword(password: string, passwordValidation: string, token: string) {
  return async (dispatch: any) => {
    dispatch({ type: RESET_PASSWORD });

    try {
      await AuthenticationAPI.resetPassword(password, passwordValidation, token);
      dispatch({ type: RESET_PASSWORD_SUCCESS });
    } catch (error) {
      dispatch({ type: RESET_PASSWORD_FAILURE, error: error });
    }
  };
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/authentication/actions/authenticationActions.js